import React, { useEffect, useRef } from 'react';
import { DropTarget } from 'react-dnd';
var Component = function Component(_ref) {
  var children = _ref.children,
    onDragLeave = _ref.onDragLeave,
    connectDropTarget = _ref.connectDropTarget,
    isOver = _ref.isOver,
    canDrop = _ref.canDrop;
  var prevIsOverRef = useRef(); // To prevent initial call (isOver is false initially)

  useEffect(function () {
    if (prevIsOverRef.current === true && isOver === false && canDrop) {
      onDragLeave === null || onDragLeave === void 0 ? void 0 : onDragLeave();
    }
    prevIsOverRef.current = isOver;
  }, [isOver, canDrop, onDragLeave]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, children(connectDropTarget));
};
export var DragDropContainer = DropTarget(function (props) {
  return props.type;
}, {}, function (connect, monitor) {
  return {
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver({
      shallow: false
    }),
    canDrop: monitor.canDrop()
  };
})(Component);